import { CSSProperties } from 'react';
import { Text } from '~/commonComponents';
import { ReceiptV2Status } from '~/models';
import { Colors } from '~/themes/colors';

interface IProps {
  status: ReceiptV2Status;
}

export const ReceiptStatus = ({ status }: IProps) => {
  const getStyles = (): CSSProperties => {
    switch (status.toLowerCase()) {
      case ReceiptV2Status.Pending.toLowerCase():
        return {
          color: Colors.success_500,
        };
      case ReceiptV2Status.Refunded.toLowerCase():
        return {
          color: Colors.success_500,
        };
      case ReceiptV2Status.Successful.toLowerCase():
        return {
          color: Colors.primary_500,
        };
      default:
        return {
          color: Colors.neutral_600,
        };
    }
  };

  return (
    <Text
      bold
      fontSize={12}
      textAlign="center"
      style={{ ...getStyles() }}
      textTransform="uppercase"
    >
      {status}
    </Text>
  );
};
